import React, { useState } from 'react'
import { GelRadioButtonGroup, GelRadio } from '@tal-gel/components'

// Type is One
const RadioButtonGroup = ({ question, onQuestionAnswered }) => {
  const [radioGroupValue, setRadioGroupValue] = useState(null)
  const [disabled, setDisabled] = useState(false)

  const onChange = (e) => {
    const { value } = e.target
    setDisabled(true)
    setRadioGroupValue(value)

    // animation 400ms then use on question answered
    setTimeout(() => {
      setRadioGroupValue(null)
      setDisabled(false)
      onQuestionAnswered({ [question.apiName]: value })
    }, 400)
  }

  const { answers, title } = question

  return (
    <GelRadioButtonGroup
      gap='medium'
      value={radioGroupValue}
      onChange={onChange}
      required
      disabled={disabled}
      errorMsg={{
        required: 'This field is required'
      }}
      buttonsPerRow={1}
      labelLeft
    >
      {answers.map((item) => (
        <GelRadio value={item.value} key={`${title} - ${item.value}`}>
          {item.title}
        </GelRadio>
      ))}
    </GelRadioButtonGroup>
  )
}

export default RadioButtonGroup
